import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel, TextField, Chip, Paper, Link } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import planilhaExemplo from "../../assets/planilha.xlsx";

const ContactListImportModal = ({ open, onClose, contactListId, onImported }) => {
  const [mode, setMode] = useState("file");
  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState(null);
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (open && mode === 'tag') {
      (async () => {
        try {
          const { data } = await api.get(`/tags/list`);
          setTags(data);
        } catch (err) {
          toastError(err);
        }
      })();
    }
  }, [open, mode]);

  const handleImportFromTag = async () => {
    if (!selectedTag) return;
    try {
      const { data } = await api.post(`/contact-lists/${contactListId}/import-from-tag`, { tagId: selectedTag.id });
      if (onImported) onImported(data);
      onClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleImportFromFile = async () => {
    if (!file) return;
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await api.request({
        url: `contact-lists/${contactListId}/upload`,
        method: "POST",
        data: formData,
      });
      if (onImported) onImported(data);
      onClose();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{i18n.t("contactListItems.confirmationModal.importTitlte")}</DialogTitle>
      <DialogContent>
        <FormControl component="fieldset">
          <FormLabel component="legend">{i18n.t("contactLists.table.actions")}</FormLabel>
          <RadioGroup row value={mode} onChange={(e) => setMode(e.target.value)}>
            <FormControlLabel value="file" control={<Radio color="primary" />} label={i18n.t("contactListItems.buttons.import")} />
            <FormControlLabel value="tag" control={<Radio color="primary" />} label={i18n.t("tags.title")} />
          </RadioGroup>
        </FormControl>

        {mode === 'tag' && (
          <Autocomplete
            options={tags}
            value={selectedTag}
            onChange={(e, v) => setSelectedTag(v)}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label={i18n.t("tickets.filters.tags")} />
            )}
          />
        )}

        {mode === 'file' && (
          <Paper style={{ padding: 12, marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <span>{i18n.t("contactListItems.confirmationModal.importMessage")}</span>
            <Link href={planilhaExemplo} download="planilha.xlsx">
              {i18n.t("contactListItems.download")}
            </Link>
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setFile(e.target.files && e.target.files[0])}
              style={{ marginTop: 8 }}
            />
          </Paper>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">{i18n.t("contactModal.buttons.cancel")}</Button>
        {mode === 'tag' && (
          <Button onClick={handleImportFromTag} color="primary" variant="contained" disabled={!selectedTag}>{i18n.t("contactLists.buttons.add")}</Button>
        )}
        {mode === 'file' && (
          <Button onClick={handleImportFromFile} color="primary" variant="contained" disabled={!file}>{i18n.t("contactListItems.buttons.import")}</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ContactListImportModal;


